// extracted by mini-css-extract-plugin
export default {"footer":"department-form-modal_footer__+RuxU","body":"department-form-modal_body__d7nAg"};